import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { FormControl } from '@mui/material'
import { getThemeSpacing } from '../../../styles/appTheme'
import { APP_FONT } from '../../../theme'

export const StyledFormControl = styled(FormControl)({
    paddingBottom: getThemeSpacing(1),
    minWidth: 120,
    width: '100%',
    font: 'inherit',
    fontSize: 13,
    '& .MuiInputLabel-root': {
        fontFamily: 'inherit',
    },
    '& .MuiNativeSelect-select': {
        fontFamily: APP_FONT,
    },
})

export const modelNameStyles = css({
    fontSize: '14px',
    fontWeight: 600,
})
